import styled from '@emotion/styled';
import React from 'react';
import Autocomplete from './Autocomplete';

const Wrapper = styled.div`
  display: flex;
  z-index: 30;
`;

const SearchArea = styled.div`
  width: 100%;
`;

function SearchBar() {
  return (
    <Wrapper id="search-bar">
      <SearchArea>
        <Autocomplete />
      </SearchArea>
    </Wrapper>
  );
}

export default SearchBar;
